import { useTranslation } from 'react-i18next';
import Select from 'src/shared/components/Form/Select';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import useMediaQuery from 'src/shared/hooks/useMediaQuery';
import { SaldoStats } from './components/SaldoStats';
import { SelectItem } from './components/SelectItem';
import { MenuItemWrapper } from './styles';
import { type CompanyToSelect } from '../../types';
import { type SelfFundedAccount } from 'src/shared/types/company';
import { getStatusOfCompany } from 'src/modules/SaldoView/utils';
import getNumericBalance from 'src/shared/utils/getNumericBalance';

type CompanySelectorBarProps = {
  dataToSelect: CompanyToSelect[];
  account: SelfFundedAccount | undefined;
};

export const CompanySelectorBar = ({ dataToSelect, account }: CompanySelectorBarProps) => {
  const { t } = useTranslation('common');
  const isMD = useMediaQuery('md');
  const status = getStatusOfCompany(account);
  return (
    <Grid2 container alignItems="center">
      <Grid2 mb={isMD ? 4 : 0}>
        <Select
          sx={{
            width: 310,
            background: 'white',
            paddingRight: '16px',
            '.MuiSelect-icon': { marginRight: '16px' }
          }}
          label={t('Company')}
          name={'selectedCompany'}
        >
          {dataToSelect?.map(({ label, value, status }) => (
            <MenuItemWrapper key={label} value={value}>
              <SelectItem status={status} label={label} />
            </MenuItemWrapper>
          ))}
        </Select>
      </Grid2>
      <Grid2
        mb={isMD ? 4 : 0}
        display="flex"
        flexDirection={isMD ? 'column' : 'row'}
        flexGrow={1}
        justifyContent="space-evenly"
        width={isMD ? '100%' : 'auto'}
      >
        <SaldoStats
          status={status}
          currentBalance={getNumericBalance(account?.balance ?? 0)}
          lowOnFundsThreshold={account?.lowOnFundsThreshold ?? 0}
        />
      </Grid2>
    </Grid2>
  );
};
